import request from "superagent";
import { getAuthHeader } from "src/utils/superagent";
import { environmentConfig } from "@src/appV2/environment";

const workerReviewServiceUrl = environmentConfig.REACT_APP_SHIFT_REVIEW_API_URL;

export type ListOfWorkersQuery = {
  category: ShiftCategory;
  search?: string;
  facilityId: string;
  pageSize: number;
  pageToken?: string;
};

export interface WorkerReview {
  id: string;
  rating: number;
  qualities: string[];
  additionalFeedback: string;
  dnrWorker: false;
  workplaceUserId: string;
  workerId: string;
  shiftId: string;
  workplaceId: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
}

export enum ShiftCategory {
  UPCOMING = "upcoming",
  IN_PROGRESS = "in_progress",
  PAST = "past",
}
export type WorkerWithShifts = {
  shifts: {
    past: number;
    inprogress: number;
    upcoming: number;
    lastShiftId?: string;
    lastShiftStart?: string;
    lastShiftEnd?: string;
    cancelled?: number;
    hasRecentCancellation?: boolean;
    cancelledInLastMonth?: number;
  };
  id: string;
};

export type WorkerWithFullDetails = WorkerWithShifts & {
  userId: string;
  profileImageUrl?: string;
  name: string;
  qualification: string;
  matchingFacilityQualifications?: string[];
};

export type ListWorkersResponse = {
  workers: WorkerWithFullDetails[];
  nextPageToken?: string;
};

type HighRatingWorkersQuery = {
  searchTerm?: string;
  sortBy?: "distance" | "name";
  sortOrder?: "asc" | "desc";
  pageNumber: number;
  pageSize: number;
  workplaceId: string;
};

export type WorkerDirectory = {
  name: string;
  workerId: string;
  averageRating: number;
  distance: number;
  ratingsCount: number;
  completedShiftsCount: number;
  attendanceRate: number;
  matchingFacilityQualifications: string[];
  profileImageUrl?: string;
  profileVideoUrl?: string;
};

export type GetWorkersDirectoryResponse = {
  workers: WorkerDirectory[];
  pageNumber: number;
  pageSize: number;
};
export async function fetchHighRatingWorkers(
  query: HighRatingWorkersQuery
): Promise<GetWorkersDirectoryResponse> {
  const response = await request
    .get(`${workerReviewServiceUrl}/workers-directory`)
    .set(await getAuthHeader())
    .query(query);
  return response.body;
}

export type GetWorkerDirectoryResponse = Omit<WorkerDirectory, "distance"> &
  Partial<Pick<WorkerDirectory, "distance">>;
export async function fetchHighRatingWorker(query: {
  workerId: string;
  workplaceId: string;
}): Promise<GetWorkerDirectoryResponse> {
  const response = await request
    .get(`${workerReviewServiceUrl}/workers-directory/${query.workerId}`)
    .set(await getAuthHeader())
    .query(query);
  return response.body;
}
